const postPlacesStr = {
  toastr: 'Lugar adicionada',
  toastr1: 'foi adicionado com sucesso',
  toastrError: 'Lugar já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postPlacesStr;
